export type ThemeMode = 'light' | 'dark';

const STORAGE_KEY = 'mockloc-theme';

export function readStoredTheme(): ThemeMode {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === 'light' || stored === 'dark') {
      return stored;
    }
  } catch {
    /* Private mode can block storage. Fall through to the default. */
  }
  return 'dark';
}

/** Public marketing home, including share links that reuse that page. */
export function isGuestHomePath(pathname: string): boolean {
  return (
    pathname === '/' ||
    pathname.startsWith('/dl-stpoint') ||
    pathname.startsWith('/dl-playlist-points') ||
    pathname.startsWith('/dl-itinerary')
  );
}

export function storeTheme(theme: ThemeMode): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    /* Ignore storage failures. The in-memory choice still applies. */
  }
}

export function applyTheme(theme: ThemeMode): void {
  document.documentElement.dataset.theme = theme;
  document.documentElement.style.colorScheme = theme;
}
